import axios from 'axios';
import { utils } from '@/utils';
import { configureSessionInterceptors } from '@/session/axiosInterceptors';

const baseURL =
  utils.constants.ASTUR_DEFAULTS.defaultConfig === 'prd'
    ? utils.constants.ASTUR_DEFAULTS.config.prd.channelApiHost
    : utils.constants.ASTUR_DEFAULTS.config.dev.channelApiHost;

const instance = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});
configureSessionInterceptors(instance, {
  etagMethods: new Set(['put']),
  transport: 'channelApi',
});

export const channelApi = instance;
